<template>
    <div class="h-screen w-full" v-html="termsAndConditionsResponse?.terms_and_conditions_text" />
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {



    data() {
        return {

        };
    },

    computed: {
        ...mapGetters([
            "termsAndConditionsResponse"
        ]),
    },


    watch: {

        termsAndConditionsResponse: function () {

        }

    },

    mounted() {
        this.getTermsAndConditions({
            "language_code": "en",
            "terms_type": "protection-plan"
        })
    },

    methods: {
        ...mapActions([
            "getTermsAndConditions"
        ]),
    }
};
</script>